<template>

  <v-container>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-dialog v-model="verifiedDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Verification Successful</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>You have successfully verified an email address.</p>

          <p>Click OK to enter the system using your verified email address and password.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="verifiedOk" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="emailAlreadyVerifiedDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Verification Failed</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>This email address has already been verified.</p>

          <p>Click OK to enter the system using your verified email address and password.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="emailAlreadyVerifiedOkDialog" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

  </v-container>

</template>

<script>

import axios from "axios";

export default {

  name: "VerifyEmail",

  methods:
      {
        verifiedOk()
        {
          if (this.$route.path != '/Login') this.$router.push('/Login');
        },
        emailAlreadyVerifiedOkDialog()
        {
          if (this.$route.path != '/Login') this.$router.push('/Login');
        }
      },

  created()
  {
    var token = this.$route.query.token;

    this.overlay = true;

    setTimeout( async () => {

          let obj = await axios.get('/Accounts/verify-email?token=' + token);

          this.overlay = false;

          if (obj.data == '%%EMAIL_ALREADY_VERIFIED%%')
          {

            this.emailAlreadyVerifiedDialog = true;

          }
          else {

            this.verificationStatus = 'verified';

            this.verifiedDialog = true;

          }

        }, 100

    );

  },

  data: () => {

    return {

      overlay: false,

      verificationStatus: 'verifying',

      verifiedDialog: false,

      emailAlreadyVerifiedDialog: false

    }

  }

}

</script>

<style>

.word-break {

  word-break: break-word;

}

</style>
